const IMAGE_FALLBACK_WIDTH = 300;
const useFallbackWidthStyle = ({
  containerData,
  isMobile
}) => {
  var _a, _b, _c;
  const shouldUseFallbackWidth = ((containerData == null ? void 0 : containerData.alignment) === "LEFT" || (containerData == null ? void 0 : containerData.alignment) === "RIGHT") && !((_a = containerData.width) == null ? void 0 : _a.custom) && ((_b = containerData.width) == null ? void 0 : _b.size) !== "SMALL" && ((_c = containerData.width) == null ? void 0 : _c.size) !== "ORIGINAL" && !isMobile;
  return shouldUseFallbackWidth ? { width: IMAGE_FALLBACK_WIDTH + "px" } : {};
};
export {
  useFallbackWidthStyle
};
//# sourceMappingURL=use-fallback-width-style.js.map
